module.exports = {"width":168,"height":112,"type":"png"}